if($('.in-index').length){
    $('.homepage-blog-wrapper .h2').text('Můj blog')
    $(document).ready(function () {
        function mh_remove(){
            $('.blog-feed .news-item').not(":nth-child(-n+5)").remove();
            $('.news-item img').each(function(){
                $(this).attr('src', $(this).attr('data-src'))
            })
        }
        if(sessionStorage.blog_feed) {
          $('.blog-feed').append(sessionStorage.blog_feed)
          $('.news-item img').each(function(){
            $(this).attr('src', $(this).attr('data-src'))
        })
          $('.news-item').attr('style', 'opacity:1;')
        } else {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/blog/",
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find("#newsWrapper").html();
                null !== t && ($(".blog-feed").html(t), mh_remove(), cteniClanku())
                sessionStorage.blog_feed = $(".blog-feed").html();
                $('.news-item').attr('style', 'opacity:1;')
                }
            });
        }
    })
    
}

$(document).ready(function () {
    function mhremove(){
        $('.citateInner .news-item').not(":nth-child(-n+3)").remove();
    }
    if(sessionStorage.blogRadi) {
      $('.citateInner').append(sessionStorage.blogRadi)
      $('.news-item').attr('style', 'opacity:1;')
    } else {
      $.ajax({
        type: "GET",
        dataType: "html",
        timeout: 1e4,
        cache: !0,
        url: "/radi-citate/",
        success: function(e) {
            var a = shoptet.common.createDocumentFromString(e),
            t = $(a).find("#newsWrapper").html();
            null !== t && ($(".citateInner").html(t), mhremove(), cteniClanku())
            sessionStorage.blogRadi = $(".citateInner").html();
            $('.news-item').attr('style', 'opacity:1;')
            }
        });
    }
})


function cteniClanku(){
    $('.news-item').each(function(){
        var readingSpeed = 800;
        var readingTime = $(this).text().length / readingSpeed;
        var htmlBlog = '<div class="text-custom">'
        htmlBlog += '<span class="title"><a href="'+$(this).find('.text>a').first().attr('href')+'">'+$(this).find('.text>a').first().text()+'</a></span>'
       
        if ($(this).find('p').first().text().length > 200) {
            var truncatedText = $(this).find('p').first().text().slice(0, 200) + "...";
            htmlBlog += '<p>'+truncatedText+'</p>'
        }
        else{
            var truncatedText = $(this).find('p').first().text();
            htmlBlog += '<p>'+truncatedText+'</p>'
        }

        
       // htmlBlog += '<span class="read-article">Čítať článok <i class="icon-arrow-right"></i></span>'
       htmlBlog += '<div class="reading-time"><span class="time">'+Math.ceil(readingTime)+' minút čítania</span></div>'
        htmlBlog += '</div>'
        if(!$(this).find('.text-custom').length){
           $(this).find('.text').after(htmlBlog)
        }
        
        
    })
    
    
}

